const TronIcon = (props) => {
  return (
    <svg
      width="60"
      height="40"
      viewBox="0 0 60 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="60" height="40" rx="8" fill="white" />
      <g clip-path="url(#clip0_11443_35440)">
        <path
          d="M41.082 15.23C39.957 14.1913 38.4008 12.605 37.1333 11.48L37.0583 11.4275C36.9335 11.3273 36.7928 11.2487 36.642 11.195C33.5858 10.625 19.362 7.96626 19.0845 8.00001C19.0068 8.0109 18.9324 8.0391 18.867 8.08251L18.7958 8.13876C18.708 8.22786 18.6414 8.3355 18.6008 8.45376L18.582 8.50251V8.76876V8.81001C20.1833 13.2688 26.5058 27.875 27.7508 31.3025C27.8258 31.535 27.9683 31.9775 28.2345 32H28.2945C28.437 32 29.0445 31.1975 29.0445 31.1975C29.0445 31.1975 39.9045 18.0275 41.0033 16.625C41.1455 16.4523 41.2711 16.2664 41.3783 16.07C41.4056 15.9163 41.3927 15.7582 41.3408 15.611C41.2889 15.4638 41.1997 15.3325 41.082 15.23ZM31.8308 16.7638L36.4658 12.92L39.1845 15.425L31.8308 16.7638ZM30.0308 16.5125L22.0508 9.97251L34.962 12.3538L30.0308 16.5125ZM30.7508 18.2263L38.9183 16.91L29.5808 28.16L30.7508 18.2263ZM20.967 10.625L29.3633 17.75L28.1483 28.1675L20.967 10.625Z"
          fill="#FF060A"
        />
      </g>
      <defs>
        <clipPath id="clip0_11443_35440">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(18 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TronIcon;
